import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  computed,
  input,
  inject,
} from '@angular/core';
import { HeaderService } from './data-access/header.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TooltipDirective } from '../../../../shared/directives/tooltip/tooltip.directive';
import { SidebarService } from '../../data-access/sidebar.service';

@Component({
    selector: 'side-bar-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    imports: [
        CommonModule,
        TooltipDirective,
        RouterModule,
    ]
})
export class HeaderComponent implements OnInit {
  @Input('sideNav') drawer: any; // Changed from MatDrawer to any

  @Input('pages') pages;

  @Output('openPage') _openPage = new EventEmitter<any>();
  @Output('close') closeEvent = new EventEmitter<void>();

  title = computed(() => this.headerService.headerDetails()?.title ?? "Unknown");

  backRoute = computed(() => this.headerService.headerDetails()?.backRoute ?? '../')

  private sidebarService = inject(SidebarService);

  constructor(
    public headerService: HeaderService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    // No longer need to set route config since items handle their own routing
  }

  goBack(route: string | Array<string>): void {
    this.headerService.navigateToParent(route);
  }

  test() {
    this.router.navigate(['../'], { relativeTo: this.route });
  }

  close() {
    this.closeEvent.emit();
  }

  openPage(pageDefinition: any) {
    console.log('Header openPage called with:', pageDefinition);
    
    // Check if this is a component item (has id property)
    if (pageDefinition.id) {
      console.log('Component item clicked, toggling:', pageDefinition.id);
      this.sidebarService.toggleComponentItem(pageDefinition.id);
    } else {
      console.log('Route item clicked, emitting openPage event');
      this._openPage.emit(pageDefinition);
    }
  }

  getSidebarIconTemplate(id: string): any {
    return this.sidebarService.getSidebarIconTemplate(id);
  }
}
